import { render, staticRenderFns } from "./base-worker-items.vue?vue&type=template&id=1d34a3d1&"
import script from "./base-worker-items.vue?vue&type=script&lang=js&"
export * from "./base-worker-items.vue?vue&type=script&lang=js&"
import style0 from "./base-worker-items.vue?vue&type=style&index=0&id=1d34a3d1&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports